export default __webpack_public_path__ + "static/Colgate-d031939fe1618f4a6b117571b1ef1130.png";